import { useCallback } from "react";

// TODO(anton): Discuss replacing with React Router v6 useNavigate() or ComponentLink
import { useNavigateTo } from "../../components/react/link/hooks";
import { COMPONENT_PATH } from "../../routes/Routes";

export type ComponentViewMode = "highlights" | "metrics" | "traces";

export const useNavigateToComponent = (): ((identifier: string, mode?: ComponentViewMode) => void) => {
	const navigateTo = useNavigateTo();

	return useCallback(
		(identifier: string, mode: ComponentViewMode = "highlights") => {
			navigateTo(COMPONENT_PATH, {
				params: { identifier, mode },
			});
		},
		[navigateTo],
	);
};
